// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_EntregasItemsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/entregas/items
 *
 * List of all not-yet-delivered service order items, enriched with
 * per-item pickup notification aggregates and a computed status field.
 * Replaces the narrower Orders_PickupNotificationsPendingResponse which
 * only surfaced PRONTO items lacking a notification.
 */
import type { Orders_EntregasItemRow } from './Orders_EntregasItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Orders_EntregasItemsResponseDados = Orders_EntregasItemRow[];

export type Orders_EntregasItemsResponse = ApiResponse<Orders_EntregasItemsResponseDados>;

registerResponseContract('Orders_EntregasItemsResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_order_item_id:                   { type: 'number',  required: true },
      so_order_item_franchise_id:         { type: 'number',  required: true },
      so_order_id:                        { type: 'number',  required: true },
      so_order_client_id:                 { type: 'number',  required: false },
      so_order_client_name:               { type: 'string',  required: false },
      so_order_item_type:                 { type: 'string',  required: true },
      so_service_name:                    { type: 'string',  required: false },
      so_service_priority_name:           { type: 'string',  required: false },
      so_product_name:                    { type: 'string',  required: false },
      so_order_item_description:          { type: 'string',  required: false },
      so_order_item_quantity:             { type: 'number',  required: false },
      so_order_item_qrcode:               { type: 'string',  required: false },
      so_order_item_created_at:           { type: 'string',  required: true },
      so_order_item_expected_delivery_at: { type: 'string',  required: false },
      so_order_item_ready_at:             { type: 'string',  required: false },
      days_since_ready:                   { type: 'number',  required: false },
      cliente_whatsapp_phone:             { type: 'string',  required: false },
      item_status:                        { type: 'string',  required: true },
      last_notification_at:               { type: 'string',  required: false },
      notification_count:                 { type: 'number',  required: false },
      days_since_last_notification:       { type: 'number',  required: false },
      urgency_score:                      { type: 'number',  required: false },
      franquia:                           { type: 'string',  required: false },
      days_until_due:                     { type: 'number',  required: false },
      so_service_category_name:           { type: 'string',  required: false },
      item_description_value:             { type: 'string',  required: false },
      _total_items:                       { type: 'number',  required: false },
      _delivered_items:                   { type: 'number',  required: false },
      item_exit_photo_url:                { type: 'string',  required: false },
    },
  },
})
